// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"238":"9253dc47","408":"63723f8c","701":"a4bf146a"}[chunkId] + ".chunk.css";
};